import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0cfb3024&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Header.vue?vue&type=style&index=0&id=0cfb3024&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0cfb3024",
  null
  ,true
)

export default component.exports